import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import {signOutWithAudit as signOut} from '../lib/auditLogger';
import { auth } from '../lib/firebase'; // Adjust path
import { useAuth } from '../contexts/AuthContext'; // Adjust path

const Layout = ({ setModal }) => {
    const { user, userData } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate('/login');
        } catch (error) {
            console.error("Logout Error", error);
            if(setModal) setModal({ show: true, message: "Logout failed" });
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <header className="bg-white shadow-sm sticky top-0 z-50">
                <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex flex-wrap gap-3 justify-between items-center">
                    <div className="flex items-center gap-3">
                         <img src="https://firebasestorage.googleapis.com/v0/b/exam-platform-v2.firebasestorage.app/o/public%2FInstill%20logo%20copy.png?alt=media&token=811c3b74-7d3d-4988-9310-dbc0e8267304" alt="Instil Learning Hub Logo" className="w-10 h-10" />
                         <div>
                            <h1 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">Instil Learning Hub</h1>
                            {user && <p className="text-sm text-gray-500">Welcome, {userData?.name || user.email} ({userData?.role || 'User'})</p>}
                         </div>
                    </div>
                    {user && (
                        <div className="flex flex-wrap justify-end items-center gap-2">{userData?.role==='student' && <button className="guide-header-link" onClick={()=>navigate('/student-guide')}>▷ Student guide</button>}<button onClick={() => navigate('/tracker')} className="bg-pink-50 text-pink-700 px-4 py-2 rounded-lg font-semibold hover:bg-pink-100">Study tracker</button>
                        <button onClick={handleLogout} className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition shadow-sm">
                            Logout
                        </button></div>
                    )}
                </div>
            </header>
            <main>
                {/* This is where the child routes (Dashboard, Exam, etc.) render */}
                <Outlet /> 
            </main>
        </div>
    );
};

export default Layout;
